import styled from 'styled-components';

import ActionButton from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { RewardsCarousel } from 'components/rewards-carousel';

const MOBILE_LOYALTY_ICON_SIZE = 2.1;
const DESK_LOYALTY_ICON_SIZE = 3.795;
const MOBILE_POINTS_SIZE = 3.125;
const DESK_POINTS_SIZE = 4.375;

export const PointsWrapper = styled.div`
  display: flex;
  flex-grow: 1;

  ${Styles.desktop} {
    flex-grow: 0;
  }
`;

export const StyledPointsIcon = styled(LoyaltyPointsIcon)`
  width: ${MOBILE_LOYALTY_ICON_SIZE}rem;
  height: ${MOBILE_LOYALTY_ICON_SIZE}rem;
  align-self: baseline;
  margin-block-start: -0.4rem;

  ${Styles.desktop} {
    width: ${DESK_LOYALTY_ICON_SIZE}rem;
    height: ${DESK_LOYALTY_ICON_SIZE}rem;
    margin-block-start: -0.8rem;
  }
`;

export const StyledPoints = styled.span`
  color: ${Styles.color.tertiary};
  font-size: ${MOBILE_POINTS_SIZE}rem;
  line-height: 0.58;
  font-family: ${Styles.fontFamily.alternative};

  ${Styles.desktop} {
    font-size: ${DESK_POINTS_SIZE}rem;
  }
`;

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  ${Styles.mobile} {
    flex-wrap: wrap;
  }
`;

export const Wrapper = styled.div`
  border-radius: ${Styles.borderRadius};
  background-color: ${Styles.color.white};
  padding-block-start: 1.5rem;
  padding-block-end: 0;
  padding-inline: 0;
  overflow: hidden;

  ${Styles.desktop} {
    padding-block-start: 2rem;
    padding-block-end: 0;
    padding-inline: 1.875rem;
  }
`;

export const StyledActionButton = styled(ActionButton)`
  align-self: baseline;
  font-size: 0.875rem;
  padding: 0.437rem 0.875rem;
  line-height: 1;

  ${Styles.desktop} {
    font-size: 1rem;
    padding: 0.687rem 1.468rem;
    margin-inline-start: 1rem;
  }
`;

export const RewardsText = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.875rem;
  margin-block-start: 0.7rem;
  order: 1;
  flex-grow: 2;
  width: 100%;

  ${Styles.desktop} {
    font-family: ${Styles.fontFamily.base};
    width: max-content;
    order: 0;
    margin-block: 0;
    margin-inline-start: 1.5rem;
    margin-inline-end: 0;
    font-size: 1.25rem;
    line-height: 1;
  }
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 18rem;
  width: 100%;
`;

export const StyledRewardsCarousel = styled(RewardsCarousel)`
  margin-block-start: -0.5rem;

  ${Styles.desktop} {
    margin-block-start: 0.5rem;
  }
`;
